import {
  TIMESLOTS_DEFAULT_PACKAGE_GET_REQUEST,
  TIMESLOTS_DEFAULT_PACKAGE_GET_SUCCESS,
  TIMESLOTS_DEFAULT_PACKAGE_GET_FAILURE,
  TREATMENT_DETAILS_GET_REQUEST,
  TREATMENT_DETAILS_GET_SUCCESS,
  TREATMENT_DETAILS_GET_FAILURE,
  TIMESLOT_ADD,
  TIMESLOT_EDIT,
  TIMESLOT_DELETE,
  TIMESLOT_SAVE_SUCCESS,
  TIMESLOT_SAVE_FAILURE,
  TIMESLOT_SAVE_REQUEST,
} from '../../../actions/constants/types';
import { getPreviousName } from '../../../utils/timeslots';

const initialPackagesState = {
  validationMessage: '',
  isFetching: false,
  timeSlotPackage: {
    timeSlots: [
      {
        from: '0001-01-01T00:00:00',
        to: '0001-01-01T01:00:00',
        startTime: '00:00:00',
        duration: 60,
        endTime: '01:00:00',
        isTwilight: true,
        name: 'A',
      },
    ],
  },
};

function packages(state = initialPackagesState, action) {
  switch (action.type) {
    case TIMESLOTS_DEFAULT_PACKAGE_GET_REQUEST:
    case TREATMENT_DETAILS_GET_REQUEST:
      return {
        ...state,
        isFetching: true,
      };
    case TIMESLOTS_DEFAULT_PACKAGE_GET_SUCCESS:
    case TREATMENT_DETAILS_GET_SUCCESS:
      return {
        isFetching: false,
        timeSlotPackage: action.response.data.defaultTimeSlots || initialPackagesState.timeSlotPackage,
      };
    case TIMESLOTS_DEFAULT_PACKAGE_GET_FAILURE:
    case TREATMENT_DETAILS_GET_FAILURE:
      return {
        ...state,
        isFetching: false,
      };
    case TIMESLOT_ADD:
      return {
        ...state,
        isFetching: false,
        timeSlotPackage: { timeSlots: [...state.timeSlotPackage.timeSlots, action.newTimeSlot] },
      };
    case TIMESLOT_EDIT:
      return {
        ...state,
        timeSlotPackage: {
          timeSlots: state.timeSlotPackage.timeSlots.map(item =>
            item.name === action.updatedTimeSlot.name ? action.updatedTimeSlot : item,
          ),
        },
      };
    case TIMESLOT_DELETE:
      return {
        ...state,
        timeSlotPackage: {
          timeSlots: [
            ...state.timeSlotPackage.timeSlots.slice(
              0,
              state.timeSlotPackage.timeSlots.findIndex(x => x.name === action.timeSlotName),
            ),
            ...state.timeSlotPackage.timeSlots
              .slice(state.timeSlotPackage.timeSlots.findIndex(x => x.name === action.timeSlotName) + 1)
              .map(ts => ({
                ...ts,
                name: getPreviousName(ts.name),
              })),
          ],
        },
      };
    case TIMESLOT_SAVE_REQUEST:
      return {
        ...state,
        isFetching: true,
      };
    case TIMESLOT_SAVE_SUCCESS:
      return {
        ...state,
        validationMessage: '',
        isFetching: false,
      };
    case TIMESLOT_SAVE_FAILURE:
      return {
        ...state,
        validationMessage: action.message.translationKey,
        isFetching: false,
      };
    default:
      return state;
  }
}

export default packages;
